// Resultado de um jogo: vencedor pelo resultado ou, em caso de empate
// num jogo a eliminar, pelas grandes penalidades.
export function isPlayed(m) {
  return m != null && m.homeScore != null && m.awayScore != null
}

export function hasPenalties(m) {
  return isPlayed(m) && m.homePenalties != null && m.awayPenalties != null
}

export function homeWins(m) {
  if (!isPlayed(m)) return false
  if (m.homeScore !== m.awayScore) return m.homeScore > m.awayScore
  return hasPenalties(m) && m.homePenalties > m.awayPenalties
}

export function awayWins(m) {
  if (!isPlayed(m)) return false
  if (m.homeScore !== m.awayScore) return m.awayScore > m.homeScore
  return hasPenalties(m) && m.awayPenalties > m.homePenalties
}

// "(4–3 g.p.)" ou null quando não houve penáltis.
export function penaltiesLabel(m) {
  return hasPenalties(m) ? `(${m.homePenalties}–${m.awayPenalties} g.p.)` : null
}
